
import { computed, defineComponent, PropType, ref } from 'vue';
import { useStore } from "vuex";

import InfoForm from '@/components/Booking/PersonalData/InfoForm.vue';
import EasyDrop from "@/components/EasyDrop.vue";
import { SearchBookingOverview } from '@/types/models';
import { FormSearchPerson, LocaleStrings } from '@/types/paramModels';

export default defineComponent({
  name: "PersonalDataView",
  props: {
    bookingOverview: {
      type: Object as PropType<SearchBookingOverview>,
      required: true,
    },
    searchQuery: {
      type: Object,
      required: true
    },
    pageTexts: {
      type: Object,
      required: true
    },
    localeStrings: {
      type: Object as PropType<LocaleStrings>,
      required: true
    }
  },
  components: {
    EasyDrop,
    InfoForm
  },
  setup(_props) {
    const store = useStore();
    
    const personalDataIndex = computed(() => store.getters["ApplicationModule/getPersonalDataIndex"]);
    const isCurrentPersonValid = ref(false);
    const showModal = ref(false);
    const validateAllFields = ref(false);

    const searchBookingOverview = computed(() => _props.bookingOverview);

    const query = computed(() => _props.searchQuery);

    const formAdults = computed(() => {
      const hotelRooms = searchBookingOverview.value.bookingSelection.hotelRooms;
      const newAdults = Array<FormSearchPerson>();
      let personTypeIndex = 0;
      for (let roomIndex = 0; roomIndex < hotelRooms.length; roomIndex++) {
        for (let personIndex = 0; personIndex < hotelRooms[roomIndex].searchRoom.adults.length; personIndex++) {
          const newAdult = { hotelRoomIndex: roomIndex, personIndex: personIndex, personTypeIndex: personTypeIndex, isAdult: true, searchPerson: hotelRooms[roomIndex].searchRoom.adults[personIndex] } as FormSearchPerson;
          personTypeIndex++;
          newAdults.push(newAdult);
        }
      }
      return newAdults;
    });

    const formChildren = computed(() => {
      const hotelRooms = searchBookingOverview.value.bookingSelection.hotelRooms;
      const newChildren = Array<FormSearchPerson>();
      let personTypeIndex = 0;
      for (let roomIndex = 0; roomIndex < hotelRooms.length; roomIndex++) {
        for (let personIndex = 0; personIndex < hotelRooms[roomIndex].searchRoom.children.length; personIndex++) {
          const newAdult = { hotelRoomIndex: roomIndex, personIndex: personIndex, personTypeIndex: personTypeIndex, isAdult: false, searchPerson: hotelRooms[roomIndex].searchRoom.children[personIndex] } as FormSearchPerson;
          personTypeIndex++;
          newChildren.push(newAdult);
        }
      }
      return newChildren;
    });

    const setCurrentPersonValid = (isValid: boolean) => {
      isCurrentPersonValid.value = isValid;
      if(isValid) validateAllFields.value = false;
    }

    const formPersons = computed(() => {
      return [...formAdults.value, ...formChildren.value];
    });

    const adultsCount = ref(formAdults.value.length);
    const childrenCount = ref(formChildren.value.length);

    const changeIndex = (add: boolean) => {
      if (isCurrentPersonValid.value && add && personalDataIndex.value < formPersons.value.length - 1)
        store.dispatch("ApplicationModule/incrementPersonalDataIndex");
      else if (!add && personalDataIndex.value > 0)
        store.dispatch("ApplicationModule/decrementPersonalDataIndex");
      else
        validateAllFields.value = true;

      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    };

    const validateFields = () => {
      validateAllFields.value = true;
    }

    return {
      query,
      isCurrentPersonValid,
      personalDataIndex,
      adultsCount,
      childrenCount,
      formPersons,
      searchBookingOverview,
      showModal,
      setCurrentPersonValid,
      changeIndex,
      validateFields,
      validateAllFields
    }
  },
})
